<template>
	<el-container>
		<el-header v-if="!path" class="header">
			<div class="back" @click="goBack"><i class="el-icon-back"></i></div>
			<div class="title">{{$t('ImportQuestion.TextImport')}}</div>
			<div class="placeholder">1</div>
		</el-header>
		<el-main class="content-box" :class="{'content-box-height': path}">
			<div class="edit-box" shadow="never">
				<div class="left">
					<div class="head">
						<p class="head-title">{{$t('ImportQuestion.TextEditing')}}</p>
						<div class="head-btn">
							<el-button type="text" size="mini" @click="dialogVisible = true">{{$t('ImportQuestion.ExampleAndHelp')}}</el-button>
							
							<el-upload class="upload-demo" accept=".doc,.docx" name="file" :http-request="uploadSectionFile" :show-file-list="false" ref="upload" action="#">
								<el-button size="mini" ref="inputWordUpLoad">{{$t('main.import')}}Word</el-button>
							</el-upload>
							<el-dropdown class="queryBox" @command="handleCommand">
								<el-button size="mini">{{$t('main.import')}}Word</el-button>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item command="1">{{$t('main.import')}}Word</el-dropdown-item>
									<el-dropdown-item command="2">{{$t('main.DownloadTemplate')}}</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>

							<el-upload class="upload-demo" accept=".xls,.xlsx" name="file" :http-request="uploadSectionFileExlex" :show-file-list="false" ref="upload" action="#">
								<el-button size="mini" ref="inputExcelUpLoad">{{$t('main.import')}}Excel</el-button>
							</el-upload>
							<el-dropdown class="queryBox" @command="handleCommand">
								<el-button size="mini">{{$t('main.import')}}Excel</el-button>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item command="3">{{$t('main.import')}}Excel</el-dropdown-item>
									<el-dropdown-item command="4">{{$t('main.DownloadTemplate')}}</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
							
							<el-button size="mini" @click="toClearText">{{$t('ImportQuestion.ClearText')}}</el-button>
						</div>
					</div>
					<!-- <el-card class="edit-container"  shadow="never" :body-style="{ padding: '0px' }">
                        
                    </el-card> -->
                    
                    <el-input
                        class="textarea"
                        type="textarea"
                        :placeholder="$t('ImportQuestion.PasteTheDocumentHere')"
                        v-model="editTextarea">
                    </el-input>
                </div>
                
                <div class="right">
                    <div class="head">
                        <p class="head-title">{{$t('ImportQuestion.QuestionPreview')}}</p>
                        <el-button 
                            v-if="!path"
                            size="mini" 
                            type="primary" 
                            @click="createProject"
                        >{{$t('ImportQuestion.CreateProject')}}</el-button>
                    </div>
                    <el-card class="edit-body"  shadow="never" :body-style="{ padding: '0px' }">
                        <template v-if="path != '/questionTypeList'">
                            <p class="body-title">{{paper.title}}</p>
                            <p class="body-depict">{{paper.depict}}</p>
                        </template>
                        <div v-for="(item) in list" :key="item.qid">
                            <div class="question" v-if="item.questionsTypeId == '8'||item.questionsTypeId == '12'">
                                <p class="subject">Q{{item.quesIndex + 1}}. {{item.questionsName}}</p>
                                <el-radio-group v-model="item.noAnswer">
                                    <el-radio 
                                        class="option"
                                        v-for="info in item.optionList" 
                                        :key="info.oid" 
                                        :label="info.oid"
                                    >
                                        {{info.labelName}}
                                        
                                        <div 
                                            v-if="info.haveInput"
                                            class="other-input">
                                            <el-input
                                                size="mini"
                                                v-model="info.inputValue"
                                                >
                                            </el-input>
                                        </div>
                                    </el-radio> 
                                </el-radio-group>
                            </div>
                            <div class="question" v-if="item.questionsTypeId == '10'">
                                <p class="subject">Q{{item.quesIndex + 1}}. {{item.questionsName}}</p>
                                <el-checkbox-group v-model="item.noAnswer">
                                    <el-checkbox 
                                        class="option"
                                        v-for="info in item.optionList" 
                                        :key="info.oid" 
                                        :label="info.oid"
                                    >
                                        {{info.labelName}}
                                        
                                        <div 
                                            v-if="info.haveInput"
                                            class="other-input">
                                            <el-input
                                                size="mini"
                                                v-model="info.inputValue"
                                                >
                                            </el-input>
                                        </div>
                                    </el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <div class="question" v-if="item.questionsTypeId == '5'">
                                <p class="subject">Q{{item.quesIndex + 1}}. {{item.questionsName}}</p>
                                <el-input
                                    resize="none"
                                    type="textarea"
                                    :rows="item.questionsTypeId == '5' ? 1 : 3"
                                    v-model="item.noAnswer">
                                </el-input>
                            </div>
                            <div class="question" v-if="item.questionsTypeId == '25'">
                                <p class="subject">Q{{item.quesIndex + 1}}. {{item.questionsName}}</p>
                            </div>
                        </div>
                        
                    </el-card>
                </div>
            </div>
        </el-main>
        <el-dialog
            :title="$t('ImportQuestion.ExampleAndHelp')"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :visible.sync="dialogVisible"
            append-to-body
            width="50%">
            <div class="help scroll-body">
                <div class="list">
                    <p class="title">{{$t('ImportQuestion.WelcomeMessage')}}：</p>
                    <div class="content">
                        <div class="left">
                            {{$t('Paper.Depict')}}【{{$t('ImportQuestion.WelcomeMessage')}}】
                        </div>
                        <div class="right">
                            <p class="tips">{{$t('ImportQuestion.PreviewExample')}}</p>
                            <p>{{$t('Paper.Depict')}}</p>
                        </div>
                    </div>
                </div>
                <div class="list">
                    <p class="title">{{$t('main.SingleChoice')}}：</p>
                        <div class="format-box">
                            <div class="content">
                                <div class="left">
                                    <p>{{$t('ImportQuestion.Example1')}}【{{$t('main.SingleChoice')}}】</p>
                                    <p>110</p>
                                    <p>120</p>
                                    <p>119</p>
                                    <p>911</p>
                                </div>
                                <div class="right">
                                    <p class="tips">{{$t('ImportQuestion.PreviewExample')}}</p>
                                    <p>{{$t('ImportQuestion.Example1')}}</p>
                                    <el-radio-group disabled class="radio-box" v-model="radio">
                                        <el-radio>110</el-radio> 
                                        <el-radio>120</el-radio> 
                                        <el-radio>119</el-radio> 
                                        <el-radio>911</el-radio> 
                                    </el-radio-group>
                                </div>
                            </div>
                        </div>
                    </div>
                <div class="list">
                    <p class="title">{{$t('main.MultipleChoiceQuestions')}}：</p>
                    <div class="format-box">
                        <div class="content">
                            <div class="left">
                                <p>{{$t('ImportQuestion.Example2')}}【{{$t('main.MultipleChoiceQuestions')}}】</p>
                                <p>A.{{$t('ImportQuestion.ScoringMethod1')}}</p>
                                <p>B.{{$t('ImportQuestion.ScoringMethod2')}}</p>
                                <p>C.{{$t('ImportQuestion.ScoringMethod3')}}</p>
                            </div>
                            <div class="right">
                                <p class="tips">{{$t('ImportQuestion.PreviewExample')}}</p>
                                <p>{{$t('ImportQuestion.Example2')}}</p>
                                <el-checkbox-group disabled class="radio-box" v-model="radio">
                                    <el-checkbox>A.{{$t('ImportQuestion.ScoringMethod1')}}</el-checkbox> 
                                    <el-checkbox>B.{{$t('ImportQuestion.ScoringMethod2')}}</el-checkbox> 
                                    <el-checkbox>C.{{$t('ImportQuestion.ScoringMethod3')}}</el-checkbox> 
                                </el-checkbox-group>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="list">
                    <p class="title">{{$t('main.TrueOrFalse')}}：</p>
                    <div class="format-box">
                        <div class="content">
                            <div class="left">
                                <p>{{$t('ImportQuestion.Example3')}}【{{$t('ImportQuestion.TrueOrFalse')}}】</p>
                            </div>
                            <div class="right">
                                <p class="tips">{{$t('ImportQuestion.PreviewExample')}}</p>
                                <p>{{$t('ImportQuestion.Example3')}}</p>
                                <el-radio-group disabled class="radio-box" v-model="radio">
                                    <el-radio>{{$t('ImportQuestion.Yes')}}</el-radio> 
                                    <el-radio>{{$t('ImportQuestion.No')}}</el-radio> 
                                </el-radio-group>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="list">
                    <p class="title">{{$t('main.fillInTheBlanks')}}：</p>
                    <div class="content">
                        <div class="left">
                            <p>{{$t('ImportQuestion.Example4')}}【{{$t('main.fillInTheBlanks')}}】</p>
                        </div>
                        <div class="right">
                            <p class="tips">{{$t('ImportQuestion.PreviewExample')}}</p>
                            <p>{{$t('ImportQuestion.Example4')}}</p>
                        </div>
                    </div>
                </div>
                <div class="list">
                    <p class="title">{{$t('main.ParagraphDescription')}}：</p>
                    <div class="content">
                        <div class="left">
                            {{$t('ImportQuestion.Example5')}}【{{$t('main.ParagraphDescription')}}】
                        </div>
                        <div class="right">
                            <p class="tips">{{$t('ImportQuestion.PreviewExample')}}</p>
                            <p>{{$t('ImportQuestion.Example5')}}</p>
                        </div>
                    </div>
                </div>
                <div class="list">
                    <p class="title">{{$t('ImportQuestion.FormatDescription')}}：</p>
                    <div class="content-format">
                        <p>1. {{$t('ImportQuestion.FormatDescription1')}}</p>
                        <p>2. {{$t('ImportQuestion.FormatDescription2')}}</p>
                        <p>3. {{$t('ImportQuestion.FormatDescription3')}}</p>
                        <p>4. {{$t('ImportQuestion.FormatDescription4')}}</p>
                        <p>5. {{$t('ImportQuestion.FormatDescription5')}}</p>
                        <p>6. {{$t('ImportQuestion.FormatDescription6')}}</p>
                        <p>7. {{$t('ImportQuestion.FormatDescription7')}}</p>
                        <p>8. {{$t('ImportQuestion.FormatDescription8')}}</p>
                        <p>9. {{$t('ImportQuestion.FormatDescription9')}}【{{$t('ImportQuestion.ConclusionNormalEnd')}}】、【{{$t('ImportQuestion.ConclusionEarlyTermination')}}】</p>
                    </div>
                </div>
            </div>
            </el-dialog>
        <el-dialog
            :title="$t('ImportQuestion.ClearText')"
            :visible.sync="clearDialogVisible"
            width="30%"
            center :close-on-click-modal="false"
            append-to-body>
            <span>{{$t('ImportQuestion.ClearPrompt')}}</span>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="clearDialogVisible = false">{{$t('main.cancel2')}}</el-button>
                <el-button size="small" type="primary" @click="doClearText">{{$t('main.ok2')}}</el-button>
            </span>
        </el-dialog>
		
		<el-dialog
		  :title="$t('ImportQuestion.ErrorMessage')"
		  :visible.sync="errordialogVisible"
		  width="40%" :close-on-click-modal="false"
          append-to-body>
		  <p v-for="(item,index) in errorMessage" :key="index">
			  {{item}}
		  </p>
		  <span slot="footer" class="dialog-footer">
		    <el-button size="medium" type="primary" @click="errordialogVisible = false">{{$t('main.ok2')}}</el-button>
		  </span>
		</el-dialog>
		<!-- <el-dialog title="清空文本" :visible.sync="clearDialogVisible" width="30%" center :close-on-click-modal="false">
			<span>确认清空文本吗？清空后，将无法恢复已输入文本</span>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="clearDialogVisible = false">{{$t('main.cancel2')}}</el-button>
				<el-button size="small" type="primary" @click="doClearText">{{$t('main.ok2')}}</el-button>
			</span>
		</el-dialog> -->

		<!-- <el-dialog :title="$t('ImportQuestion.ErrorMessage')" :visible.sync="errordialogVisible" width="40%" :close-on-click-modal="false">
			<p v-for="(item, index) in errorMessage" :key="index">{{ item }}</p>
			<span slot="footer" class="dialog-footer"><el-button type="primary" @click="errordialogVisible = false">确 定</el-button></span>
		</el-dialog> -->
	</el-container>
</template>

<script>

import { Paper } from "./js/editPaper.js";
import { v1 as UUID } from 'uuid';
export default {
	name: 'ImportQuestion',
    props: {
        path: {
            type: String,
            default: ''
        }
    },
	data() {
		return {
			dialogWordImport:false,
			dialogExcelImport:false,
			errorMessage: [],
			errordialogVisible: false,
			editTextarea: `

${this.$t('ImportQuestion.Example1')}【${this.$t('main.SingleChoice')}】
110
120
119
911

${this.$t('ImportQuestion.Example2')}【${this.$t('main.MultipleChoiceQuestions')}】
A、${this.$t('ImportQuestion.ScoringMethod1')}
B、${this.$t('ImportQuestion.ScoringMethod2')}
C、${this.$t('ImportQuestion.ScoringMethod3')}

${this.$t('ImportQuestion.Example3')}【${this.$t('main.TrueOrFalse')}】

${this.$t('ImportQuestion.Example4')}【${this.$t('main.fillInTheBlanks')}】
\n`,
			editBody: '',
			quesType: [`【${this.$t('main.SingleChoice')}】`, `【${this.$t('main.MultipleChoiceQuestions')}】`, `【${this.$t('main.TrueOrFalse')}】`, `【${this.$t('main.fillInTheBlanks')}】`, `【${this.$t('main.ParagraphDescription')}】`],
			paper: {},
			list: [],
			dialogVisible: false,
			radio: '',
			clearDialogVisible: false,
			fullscreenLoading: false
		};
	},
	watch: {
		editTextarea: {
			handler(newV) {
				this.initialization(newV);
			}
		}
	},
	beforeCreate() {},
	created() {
		this.paper = new Paper();
		this.initialization(this.editTextarea);
        if (this.path != '/questionTypeList') {
            this.editTextarea = `
${this.$t('ImportQuestion.ProjectTitle')}
${this.$t('Paper.Depict')}【${this.$t('ImportQuestion.WelcomeMessage')}】
${this.editTextarea}
`
        }
    },
	methods: {
		language() {
			return window.localStorage.getItem('lang') || this.$defaultLang
		},
		handleCommand(command) {
			if (command == 1) {
				this.$refs.inputWordUpLoad.$el.click();
			} else if (command == 2) {
				this.downWordloadFile();
			}
			else if (command == 3) {
				this.$refs.inputExcelUpLoad.$el.click();
			}
			else if (command == 4) {
				this.downExcelloadFile();
			}
		},
		// 下载模板
		downWordloadFile() {
			this.dialogWordImport = true
			this.$axios({
				method: 'get',
				url: './template/导入文本word模板.docx',
				responseType: 'blob',
				headers:{
					'Accept-Language': this.language(),
				},
			}).then(response => {
				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				let fname = '导入文本word模板.docx';
				link.href = url;
				link.setAttribute('download', fname);
				document.body.appendChild(link);
				link.click();
				this.dialogWordImport = false;
			});
		},
		// 下载模板
		downExcelloadFile() {
			this.dialogExcelImport = true
			this.$axios({
				method: 'get',
				url: './template/文本导入excel模板.xlsx',
				responseType: 'blob',
				headers:{
					'Accept-Language': this.language(),
				},
			}).then(response => {
				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				let fname = 'Excel模板.xlsx';
				link.href = url;
				link.setAttribute('download', fname);
				document.body.appendChild(link);
				link.click();
				this.dialogExcelImport = false;
			});
		},
		uploadSectionFileExlex(params) {
			let that = this;
			var formData = new FormData();
			formData.append('file', params.file);
			let paramsUp = {
				that: that,
				url: `${that.$config.service.examimportExcel}`,
				method: 'post',
				data: formData,
				cb(res) {
					// console.log(res)
					if (res.code == '0') {
						that.editTextarea = res.message;
					} else if (res.code == '1500') {
						that.$message.error(res.message);
					} else {
						that.errorMessage = JSON.parse(res.message);
						that.errordialogVisible = true;
					}
				}
			};
			that.$util.request(paramsUp);
		},
        uploadSectionFile(params) {
            let that = this
            var formData = new FormData();
            formData.append("file", params.file);
            let paramsUp = {
                that: that,
                url: `${that.$config.service.examimportWord}`,
                method: "post",
                data: formData,
                cb(res) {
                    // console.log(res)
                    if (res.code == '0') {
                        that.editTextarea = res.message
                    }
                },
            };
            that.$util.request(paramsUp);
        },
        initialization(newV) {
            this.paper.title = ''
            this.paper.depict = ''
            this.paper.questionsList = []
            let srArray = []
            srArray = newV.split('\n')
            for(let i = 0;i<srArray.length;i++){
                if (srArray[i] != '' && this.path != '/questionTypeList'){
                    this.paper.title = srArray[i]
                    srArray.splice(0, i+1)
                    break
                }
            }
            let arr = []
            let arr2 = []
            
            srArray.forEach((info, index) => {
                if (info) {
                    if(arr.length > 0) {
                        this.quesType.forEach((item) => {
                            if (info.indexOf(item) != -1) {
                                arr2.push(arr)
                                arr = []
                            }
                        })
                    }
                    arr.push(info)
                    if(index == srArray.length - 1 && arr.length > 0){
                        arr2.push(arr)
                        arr = []
                    }
                } else {
                    if(arr.length > 0){
                        if(index == 0) {
                            this.paper.title = arr[0]
                        }
                        arr2.push(arr)
                        arr = []
                    }
                }
            })
            arr2.forEach((info, index) =>{
                if(index == 0) {
                    // console.log(info)
                    info.forEach((el, elindex)=>{
                        if (el.indexOf(`【${this.$t('ImportQuestion.WelcomeMessage')}】`) != -1 && elindex == 0){
                            this.paper.depict = el.slice(0, el.length - this.$t('ImportQuestion.WelcomeMessage').length - 2)
                        }else {
                            arr.push(el)
                        }
                    })
                    if (arr.length > 0) {
                        this.paper.createQuestion(arr)
                        arr = []
                    }
                } else {
                    this.paper.createQuestion(info)
                }
                
            })
            
            this.list = JSON.parse(JSON.stringify(this.paper.questionsList))
            this.list.forEach(info =>{
                if(info.questionsTypeId == 204 || info.questionsTypeId == 206) {
                    info.answer = `${$t('main.CorrectAnswer')}：${info.answer}`
                }
            })
        },
        toClearText() {
            this.clearDialogVisible = true
        },
        doClearText() {
            this.editTextarea = ''
            this.clearDialogVisible = false
        },
        // 根据试题序号 获取试题qid
        getQuestionQid(quesIndex) {
            let list = this.paper.questionsList.filter((info) => info.quesIndex == quesIndex)
            // console.log(list)
            return list[0].qid
        },
        setJumpLogic(info, optionId, questionId, type) {
            info.logicalSettings.num++
            info.logicalSettings.jump.type = type
            info.logicalSettings.jump.logicList.push({
                logicId: UUID(),
                questionId: questionId,
                condition:[{
                    andOr: 1,
                    qid: info.qid,
                    optionId: optionId
                }]
            })
            return info.logicalSettings
        },
        // 添加跳转逻辑 
        getJumpLogic() {
            this.paper.questionsList = this.paper.questionsList.filter(item => {return item.questionsTypeId})
            this.paper.questionsList = this.paper.questionsList.map((info, index) => {
                switch(info.questionsTypeId) {
                    case '8':
                    case '10':
                    case '12':
                        info.optionList = info.optionList.map(op => {
                            let arr = op.labelName.match(/---JumpToQ(\d+)/)
                            let endArr = op.labelName.match(/---NormalEnd/)
                            let endDArr = op.labelName.match(/---EarlyTermination/)

                            if (arr) {
                                op.labelName = op.labelName.replace(arr[0], '')
                                let questionId = this.getQuestionQid(arr[1] - 1)
                                info.logicalSettings = this.setJumpLogic(info, op.oid, questionId, 1)
                            }
                            if (endArr) {
                                op.labelName = op.labelName.replace(endArr[0], '')
                                info.logicalSettings = this.setJumpLogic(info, op.oid, 'end', 1)
                            }
                            if (endDArr) {
                                op.labelName = op.labelName.replace(endDArr[0], '')
                                info.logicalSettings = this.setJumpLogic(info, op.oid, 'endD', 1)
                            }
                            return op
                        })
                        break
                    case '5':
                        let arr = info.questionsName.match(/---JumpToQ(\d+)/)
                        let endArr = info.questionsName.match(/---NormalEnd/)
                        let endDArr = info.questionsName.match(/---EarlyTermination/)
                        if (arr) {
                            info.questionsName = info.questionsName.replace(arr[0], '')
                            let questionId = this.getQuestionQid(arr[1] - 1)
                            info.logicalSettings = this.setJumpLogic(info, 1, questionId, 0)
                        }
                        if (endArr) {
                            info.questionsName = info.questionsName.replace(endArr[0], '')
                            info.logicalSettings = this.setJumpLogic(info, 1, 'end', 0)
                        }
                        if (endDArr) {
                            info.questionsName = info.questionsName.replace(endDArr[0], '')
                            info.logicalSettings = this.setJumpLogic(info, 1, 'endD', 0)
                        }
                        break
                    default:
                        info.quesIndex = null
                        break
                }
                return info
            })
        },
        createProject() {
            this.getJumpLogic()
            // console.log(this.paper)
            let createTime = this.$functions.GetDate()
            const loading = this.$loading({
                lock: true,
                text: this.$t('ImportQuestion.Creating'),
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 0.7)'
            })
            let that = this;
            let params = {
                that: this,
                url: this.$config.service.wjadd,
                method: "post",
                data: {
                    content: "",
                    wjTitle: this.$t('Paper.Title'),
                    wjType: this.$t('main.QuestionnaireType'),
                    id: '0'
                },
                cb(res) {
                    sessionStorage.setItem("wid", res.resultBody.id);
                    sessionStorage.setItem("wstate", res.resultBody.state);
                    let paperJson = JSON.parse(JSON.stringify(that.paper))
                    paperJson.title = `<p style="text-align: center;"><span style="font-size: 20px"><strong><span style="color: #10ab97;">${paperJson.title}</span></strong></span></p>`
                    let data = {
                        id: res.resultBody.id,
                        paperjson: JSON.stringify(paperJson),
                        createTime: createTime,
                        updateTime: that.$functions.GetDate()
                    }
                    let paramsUp = {
                        that: that,
                        url: `${that.$config.service.addQuestionnaire}`,
                        method: "post",
                        data: data,
                        cb(res) {
                        // console.log(res)
                        if (res.code == '0') {
                            loading.text = that.$t('ImportQuestion.CreatedSuccessfully')
                            setTimeout(() => {
                                loading.close()
                                that.$router.replace('/questionType')
                            }, 1000)
                        } else {
                            that.$message.error(res.message)
                            loading.close()
                        }
                        },
                    };
                    that.$util.request(paramsUp);
                },
            };
            this.$util.request(params);
        },
        goBack() {
            this.$router.go(-1)
        },
    }
}
</script>

<style lang="scss" scoped>
.el-container{
    height: 100%;
}
.header {
	display: flex;
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
	justify-content: space-between;
	align-items: center;
	.back {
		[class^='el-icon-'] {
			color: #6d6d6d;
		}
		font-size: 24px;
		cursor: pointer;
		padding: 10px;
	}
	.title {
		font-size: 14px;
		color: #484848;
	}
	.placeholder {
		opacity: 0;
	}
}

.content-box-height{
    height: calc(100vh - 60px);
}
.content-box {
    height: calc(100vh - 60px);
	.edit-box {
		height: 100%;
		box-sizing: border-box;
		border: 1px solid #ebeef5;
		background-color: #fff;
		color: #303133;
		padding: 20px;
		border-radius: 4px;
		display: flex;
		justify-content: space-between;
		.head-btn {
			display: flex;
			justify-content: space-between;
			align-items: center;
			line-height: 0px;
			/deep/.el-upload {
				margin: 0 10px;
			}
			.queryBox{
				margin:0px 5px;
			}
			.upload-demo{
				display: none;
			}
		}
		.head-title {
			color: #484848;
			font-size: 14px;
		}
		.head-title::before {
			content: '';
			display: inline-block;
			margin-right: 4px;
			width: 2px;
			height: 12px;
			background: #2672ff;
			border-radius: 1px;
			vertical-align: middle;
		}
		.head {
			display: flex;
			justify-content: space-between;
			align-items: center;
			line-height: 60px;
		}
		.left,
		.right {
			width: 49.5%;
		}
		.left {
			margin-right: 0.2%;
			/deep/.el-textarea {
				height: calc(100% - 60px);
			}
			/deep/.el-textarea__inner {
				box-sizing: border-box;
				padding: 50px;
				border: none;
				resize: none;
				border: 1px solid #eaeaea;
				height: 100%;
			}
		}
		.right {
			margin-left: 0.2%;
		}
		.edit-container,
		.edit-body {
			padding: 50px;
			box-sizing: border-box;
			border: 1px solid #eaeaea;
			overflow: auto;
			margin-right: 0.5%;
			border-radius: 4px;
			height: calc(100% - 60px);
		}

		.edit-body {
			.body-title {
				font-size: 24px;
				color: #484848;
				text-align: center;
				margin-bottom: 30px;
			}
			.body-depict {
				margin-bottom: 30px;
			}
			.question {
				margin-top: 30px;
				color: #484848;
				.subject {
					margin-bottom: 20px;
					.score {
						color: #aeaeae;
					}
				}

				.option {
					margin-top: 10px;
					display: flex;
					align-items: center;
					.other-input {
						width: 80px;
						margin-left: 10px;
					}

					.other-input /deep/.el-input--mini .el-input__inner {
						height: 22px;
						line-height: 22px;
					}

					/deep/.el-checkbox__label,
					/deep/.el-radio__label {
						display: flex;
						align-items: center;
						white-space: normal;
						word-break: break-all;
						font-size: inherit;
						text-decoration: inherit;
					}
					/deep/.el-checkbox__input {
						display: inline-block;
						margin-top: 3px;
					}
				}
			}
			/deep/.el-radio + .el-radio,
			/deep/.el-checkbox + .el-checkbox {
				margin-top: 10px;
			}
			/deep/.el-textarea__inner,
			.right-key {
				color: #00bf6f !important;
			}
		}
	}
}
/deep/.el-radio-group,
/deep/.el-checkbox-group {
	display: flex;
	flex-direction: column;
}

.help {
	overflow-y: auto;
	height: 500px;
	.list {
		margin-bottom: 25px;
		.title {
			margin-bottom: 6px;
		}
		.format {
			font-size: 13px;
			margin-bottom: 12px;
			width: 48%;
			.format-info {
				color: #aeaeae;
			}
		}
		.format-box + .format-box {
			margin-top: 10px;
		}
		.content {
			display: flex;
			justify-content: space-between;
			.left {
				width: 48%;
				padding: 20px 24px;
				box-sizing: border-box;
				background: #f7f8fa;
				border-radius: 4px;
			}
			.right {
				width: 43%;
				padding: 5px 24px 0;
				border-radius: 4px;
				border: 1px solid #ebeef5;
				.tips {
					color: #aaa;
					font-size: 12px;
					text-align: right;
				}
				.score {
					color: #aeaeae;
				}
				/deep/.el-radio + .el-radio,
				/deep/.el-checkbox + .el-checkbox {
					margin-top: 5px;
				}
				/deep/.right-key {
					color: #00bf6f !important;
				}
				.radio-box {
					margin-top: 10px;
				}
				.tiankong-answer {
					display: inline-block;
					height: 30px;
					width: 330px;
					padding: 7px 12px;
					font-size: 12px;
					border: 1px solid #d8d8d8;
					border-radius: 2px;
					color: #00bf6f !important;
					box-sizing: border-box;
					margin-top: 10px;
					cursor: text;
				}
				/deep/.el-radio__input.is-disabled + span.el-radio__label,
				/deep/.el-checkbox__input.is-disabled + span.el-checkbox__label {
					color: #606266;
					cursor: auto;
				}
			}
		}
		.content-format {
			color: #484848;
			font-size: 12px;
			line-height: 20px;
		}
	}
}
/deep/.el-dialog__body {
	padding: 30px 20px;
}
</style>
